import React from 'react';

export default function IconTopArrow() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0L16 16L8 12.1905L0 16L8 0Z" fill="currentColor" />
    </svg>
  );
}
